"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NANO = void 0;
const conversions_1 = require("./lib/conversions");
class NANO {
    constructor(RAW) {
        this.plus = (other) => conversions_1.addNano(this, other);
        this.minus = (other) => conversions_1.subtractNano(this, other);
        this.RAW = RAW;
        this.asString = conversions_1.rawToNANO(RAW);
        this.asNumber = conversions_1.NANOToNumber(this);
    }
}
exports.NANO = NANO;
NANO.ZERO = new NANO('0');
NANO.fromRAW = (raw) => new NANO(raw);
NANO.fromNumber = (nano) => conversions_1.fromNANOString(nano.toString());
